import { useMedia } from 'react-use';

import * as PaginatedHorizontalScroll from '@/components/PaginatedHorizontalScroll';
import { StyledH2, StyledParagraph } from '@/components/CrossChainSwaps/utils';
import { PostPreview } from '@/components/RecentBlogPosts/PostPreview';

import { breakpoints } from '@/styles/util';

const blogPosts = [
  {
    id: '1',
    image: {
      alt: null,
      src: 'https://assets-global.website-files.com/64b702e0e92a993f08b979ce/656746fd5d7248a3294fbd86_cross%20chain%20swap%40main.png',
    },
    summary: `Seize any opportunity across 7 networks with cross chain swaps on Matcha! Trade tokens directly for a different asset on another blockchain in one go, with aggregated liquidity from 100s of DEXs.`,
    title: 'Cross chain swaps on Matcha!',
    url: 'https://blog.matcha.xyz/article/cross-chain-swaps',
  },
  {
    id: '2',
    image: {
      alt: null,
      src: 'https://assets-global.website-files.com/64b702e0e92a993f08b979ce/659ffb7e8717c121df2b90a6_Bitcoin%20ETF%20approved%40main-p-2000.jpg',
    },
    summary: `Eleven Bitcoin ETFs open for trading on US stock exchanges, fifteen years after Bitcoin first launched. What is an ETF and what does the Bitcoin ETF mean for the world of decentralized finance?`,
    title: 'Bitcoin ETF approved',
    url: 'https://blog.matcha.xyz/article/bitcoin-etf-approved',
  },
  {
    id: '3',
    image: {
      alt: null,
      src: 'https://assets-global.website-files.com/64b702e0e92a993f08b979ce/659d1ae1d26a2314bb60b4e3_USDC%20circle%40main-p-2000.jpg',
    },
    summary: `USDC is one of the most popular stablecoins thanks to wide availability across 15 networks and transparent reporting of its cash reserves. Learn how to use native USDC to trade more effectively.`,
    title: 'USDC by Circle',
    url: 'https://blog.matcha.xyz/article/usdc-by-circle',
  },
  {
    id: '4',
    image: {
      alt: null,
      src: 'https://assets-global.website-files.com/64b702e0e92a993f08b979ce/659d66c845c82f1c987877de_what%20is%20a%20stablecoin%40main.jpg',
    },
    summary: `While cryptocurrencies operate outside traditional finance, stablecoins help tether the decentralized economy to conventional currencies. Learn how different types of stablecoin work in this blog.`,
    title: 'What is a stablecoin?',
    url: 'https://blog.matcha.xyz/article/what-is-a-stablecoin',
  },
];

export const MatchaBlogSection = () => {
  const isDesktop = useMedia(breakpoints.desktop, true);
  const isTablet = useMedia(breakpoints.tablet, false);
  const isMobile = useMedia(breakpoints.mobile, false);

  const columns = isDesktop ? 4 : isTablet ? 3 : 2;
  const blogItems = blogPosts.map(({ id, ...post }) => ({ id, node: <PostPreview {...post} /> }));

  return (
    <div className="mx-auto mt-24 mb-16 max-w-[1240px]">
      <StyledH2 className="text-center">Level up in Web3</StyledH2>
      <StyledParagraph className="mb-[52px] text-center font-heading text-[18px] font-bold text-token-gray-1600">
        Learn more on Matcha blog
      </StyledParagraph>

      <PaginatedHorizontalScroll.Root
        className={''}
        columns={columns}
        isHorizontalScroll={isMobile}
        page={isMobile ? undefined : 1}
      >
        <PaginatedHorizontalScroll.List items={blogItems} />
      </PaginatedHorizontalScroll.Root>
    </div>
  );
};
